import React from 'react';
import { CloseIcon } from 'assets/icons';

interface Props {
	title?: string;
	onClose?: any;
}

const TitleModalRight = (props: Props) => {
	return (
		<div className="row title-modal-right">
			<div className="col-9">
				<h3>{ props.title }</h3>
			</div>
			<div className="col-3 text-right">
				<button className="btn btn-close" onClick={ props.onClose }>
					<img src={ CloseIcon } />
				</button>
			</div>
		</div>
	)
}

export default TitleModalRight;